import { useCallback, useEffect, useState } from "react";
import { ShieldCheck, ArrowLeft, Clock, Link2, Stethoscope } from "lucide-react";
import { InsureNowDialog } from "./InsureNowDialog";
import { QuoteRequests } from "./QuoteRequests";
import { BorderPendingAlert } from "./BorderPendingAlert";
import { insApi } from "../../lib/insApi";

const PICK = { individuals: "اختر الموظفين", cars: "اختر السيارات", moto: "اختر الدراجات", medical: "اختر الموظفين" };
const NOTE = "ملحوظة: سيتم إرسال عروض الأسعار من الشركات مباشرة خلال ساعتين من إرسال الطلب";

const Card = ({ kind, canEdit, title, sub, icon: Icon, bg, onClick, tid }) => (
  <button type="button" disabled={!canEdit} onClick={onClick} data-testid={tid}
    className={`group relative w-full overflow-hidden rounded-2xl ${bg} p-5 text-right text-white shadow-sm transition-transform duration-300 hover:-translate-y-0.5 disabled:cursor-default`}>
    <div className="pointer-events-none absolute -left-10 -top-16 h-48 w-48 rounded-full bg-emerald-400/20 blur-2xl" />
    <div className="pointer-events-none absolute left-24 -bottom-20 h-40 w-40 rounded-full bg-amber-300/20 blur-2xl" />
    <div className="relative flex flex-wrap items-center gap-4">
      <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-white/10"><Icon className="h-6 w-6 text-emerald-300" /></div>
      <div className="min-w-0 flex-1">
        <p className="font-heading text-xl font-extrabold sm:text-2xl">{title}</p>
        {sub && <p className="mt-0.5 text-xs text-white/80" data-testid={`${tid}-sub`}>{sub}</p>}
        <p className="mt-1 flex items-center gap-1.5 text-xs text-emerald-100/90 sm:text-sm"><Clock className="h-3.5 w-3.5 shrink-0" /> {NOTE}</p>
      </div>
      {canEdit && <span className="flex items-center gap-1.5 rounded-full bg-amber-400 px-4 py-2 text-sm font-bold text-[#0B3B2E] transition-transform group-hover:-translate-x-1">{PICK[kind]} <ArrowLeft className="h-4 w-4" /></span>}
    </div>
  </button>
);

export const InsureNowBanner = ({ kind, canEdit }) => {
  const [channel, setChannel] = useState(null);
  const [reqs, setReqs] = useState([]);
  const withMedical = kind === "individuals";
  const load = useCallback(() => {
    Promise.all([insApi.requests(kind), withMedical ? insApi.requests("medical") : Promise.resolve({ items: [] })])
      .then(([a, b]) => setReqs([...a.items, ...b.items].filter((r) => r.status !== "cancelled").sort((x, y) => (y.created_at || "").localeCompare(x.created_at || "")))).catch(() => {});
  }, [kind, withMedical]);
  useEffect(load, [load]);
  const withRabet = kind === "individuals" || kind === "moto";
  return (
    <div className="space-y-4">
      {canEdit && <BorderPendingAlert onUpdated={load} />}
      <div className={`grid gap-3 ${withRabet ? "xl:grid-cols-2" : ""}`}>
        <Card kind={kind} canEdit={canEdit} title="أمّن الآن بأقل الأسعار" icon={ShieldCheck} bg="bg-[#0B3B2E]" onClick={() => setChannel("market")} tid={`insure-now-banner-${kind}`} />
        {withRabet && <Card kind={kind} canEdit={canEdit} title="تأمين ربط" icon={Link2} bg="bg-[#123A5C]" onClick={() => setChannel("rabet")} tid={`insure-rabet-banner-${kind}`} />}
        {withMedical && <div className="xl:col-span-2"><Card kind="medical" canEdit={canEdit} title="فحوص طبية" sub="فحص إصدار إقامة · فحص إصدار رخص قيادة · إصدار شهادة صحية لتوصيل الطلبات" icon={Stethoscope} bg="bg-[#5B2245]" onClick={() => setChannel("medical")} tid="insure-medical-banner" /></div>}
      </div>
      <QuoteRequests items={reqs} reload={load} />
      <InsureNowDialog open={!!channel} onOpenChange={(o) => !o && setChannel(null)} kind={channel === "medical" ? "medical" : kind} channel={channel === "rabet" ? "rabet" : "market"} onSent={load} />
    </div>
  );
};
